import { Box, Button, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useUnitTypeIcon } from '../../hooks/use-unit-type-parameters'
import { ContainerJourneyCardProps } from './ContainerJourneyCard'

import { ColoredLabel, DamagedIcon, useContainerAttributesParameters } from '@tom-ui/ui'

export const ContainerJourneyCardHeader: FC<ContainerJourneyCardProps> = observer(props => {
  const {
    container,
    isDamaged,
    primaryActionLabel,
    onPrimaryAction,
    secondaryActionLabel,
    onSecondaryAction,
  } = props
  const { t } = useTranslate()
  const { types: containerTypeParameters, heights: containerHeightParameters } =
    useContainerAttributesParameters()

  let icon

  if (container.unitType === 'Container') {
    const { icon: containerIcon } = containerTypeParameters[container.type]
    icon = containerIcon
  } else {
    icon = useUnitTypeIcon(container.unitType)
  }

  return (
    <Box sx={{ padding: '1rem', display: 'flex', justifyContent: 'space-between' }}>
      <Stack direction={'column'} spacing={2}>
        <Stack direction={'row'} spacing={1} alignItems={'center'}>
          {icon}
          <Typography variant='h4' data-cy='container-visit-container-number'>
            {container.number}
          </Typography>
        </Stack>
        <Stack direction={'row'} spacing={1} alignItems={'center'}>
          {container.isoCode && <ColoredLabel color='secondary' label={container.isoCode || ''} />}
          {container.type && (
            <ColoredLabel color='secondary' label={containerTypeParameters[container.type].label} />
          )}
          {container.length && (
            <ColoredLabel
              color='secondary'
              label={`${container.length ? container.length + 'ft' : '-'}`}
            />
          )}
          {container.height && (
            <ColoredLabel
              color='secondary'
              label={containerHeightParameters[container.height]?.label || ''}
            />
          )}
          {container.maxGross && (
            <ColoredLabel
              color='secondary'
              label={`${t('maxGross', 'MaxGross')}: ${container.maxGross}`}
            />
          )}
          {isDamaged && <DamagedIcon />}
        </Stack>
      </Stack>

      <Stack direction={'row'} spacing={1} alignItems={'center'}>
        {onPrimaryAction && primaryActionLabel && (
          <Button
            variant='contained'
            color='primary'
            onClick={onPrimaryAction}
            data-cy='container-journey-primary-action-btn'
          >
            {primaryActionLabel}
          </Button>
        )}
        {onSecondaryAction && secondaryActionLabel && (
          <Button
            variant='contained'
            color='inherit'
            onClick={onSecondaryAction}
            data-cy='container-journey-secondary-action-btn'
          >
            {secondaryActionLabel}
          </Button>
        )}
      </Stack>
    </Box>
  )
})
